import { Icon } from "~/icon";

// Green success-check badge for confirmation screens (referral intake, online scheduling, etc.).
export function SuccessCheck() {
  return (
    <div class="flex size-16 items-center justify-center rounded-full bg-brand-success-light">
      <Icon name="check" size="none" class="size-8 text-brand-success" />
    </div>
  );
}
